import { render } from "./DemoRequestForm.vue?vue&type=template&id=86bd5e62&scoped=true"
import script from "./DemoRequestForm.vue?vue&type=script&lang=js"
export * from "./DemoRequestForm.vue?vue&type=script&lang=js"

import "./DemoRequestForm.vue?vue&type=style&index=0&id=86bd5e62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86bd5e62"]])

export default __exports__